import { render, staticRenderFns } from "./TeamProfileDetails.vue?vue&type=template&id=5c2ba2d0"
import script from "./TeamProfileDetails.vue?vue&type=script&lang=js"
export * from "./TeamProfileDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports